<template>
    <div>
        <div class="setting-left custom—scrollbar" :style="`height:${columnH}px`">
            <ul>
                <li @click="activeIndex = 0" :class="{'li--active': activeIndex === 0}">
                    <a href="javascript:;" class="groupLi" @click="$router.replace({path: '/main/primary/signup/signupList', query: {state: 0,noticeId:noticeId}})">全部</a>
                </li>
                <li :class="{'li--active': activeIndex === leftGroupIndex + 1}" @click="activeIndex = leftGroupIndex + 1" v-for="(leftGroupItem,leftGroupIndex) in leftGroupList" :key="leftGroupIndex" v-if="leftGroupList&&leftGroupList.length>0">
                    <a href="javascript:;" class="groupLi" @click="jumpTo('/main/primary/signup/signupList',leftGroupItem)">{{leftGroupItem.groupName}}</a>
                </li>
            </ul>
        </div>
        <div class="setting-right" :style="`height:${columnH}px`">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" @noticeIdBack="noticeIdBack"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" @noticeIdBack="noticeIdBack"></router-view>
        </div>
    </div>
</template>

<script>
import mixins from '@/mixins/windowResize';
import {getSchoolEnrolNoticeList,getNoticeGroupList} from '@/api/primary/setting.js';
export default {
    name: "SignupLayout",
    data(){
        return{
            noticeId:'',
            state:'',
            leftGroupList:[],
            activeIndex: 0,
            noticeList:[]
        }
    },
    created(){
        this.getSchoolEnrolNoticeListFunc();
    },

    mounted(){

    },
    watch:{
        '$route':{
            handler:function(to,from){
                if(to.query&&to.path.indexOf("primary/signup")!==-1){
                    this.query=to.query;
                    this.state=this.query.state;
                    if(this.query.noticeId){
                        this.noticeId=this.query.noticeId;
                    }
                }
            },
            immediate: true
        }
    },
    mixins:[mixins],
    methods:{
        noticeIdBack(val){
            
           this.noticeId=val.noticeId;
        //    if(val.activeIndex==0){
        //         this.activeIndex=val.activeIndex;
        //    }    
           if(this.noticeId){
               this.activeIndex=0;
           }
           this.getNoticeGroupListFunc();
        },
        jumpTo(url,leftGroupItem){
            this.$router.push({
               path:url,
               query:{
                   groupId:leftGroupItem.id,
                   type:leftGroupItem.type,
                   state:this.state,
                   noticeId:this.noticeId
               }
            })
        },
        getSchoolEnrolNoticeListFunc(){
            getSchoolEnrolNoticeList({
                searchVal:'',
                state:2
            }).then(res=>res.data)
            .then(data=>{
                if(data.code===200){
                    if(data.data&&data.data.length!==0){
                        let groupList=data.data;
                        this.noticeList=data.data;
                        if(this.noticeId==''){
                            this.noticeId=groupList[0].id;
                        }
                        this.getNoticeGroupListFunc();
                    }
                }
            })
        },
        getNoticeGroupListFunc(){
            getNoticeGroupList({
                noticeId:this.noticeId
            }).then(res=>res.data)
            .then(data=>{
                if(data.code===200){
                    if(data.data){
                        this.leftGroupList=data.data;
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .li--active a {
        color: #409EFF !important;
    }
    .setting-left {
        float: left;
        width: 12%;
        border-right: 1px solid #e6e6e6;

        .router-link-active {
            color: #20a0ff;
        }
        ul {
            margin: 0;
            li {
                a {
                    text-decoration: none;
                    display: block;
                    height: 56px;
                    line-height: 56px;
                    font-size: 14px;
                    color: #48576a;
                    text-align: left;
                    padding: 0 20px;
                    cursor: pointer;
                    position: relative;
                    transition: border-color .3s,background-color .3s,color .3s;
                    box-sizing: border-box;
                    white-space: nowrap;
                    &:hover {
                        background-color: #d1dbe5;
                    }
                }
                .router-link-active {
                    color: #20a0ff;
                }
            }
        }

    }
    .setting-right {
        float: right;
        width: 86%;
        height: 730px;
        overflow-y: auto;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/signup/SignupLayout.vue